import React, { useEffect, useState } from 'react';
import {Link, useParams, useNavigate} from 'react-router-dom';
import { toast } from "react-toastify";
import AdminCashierAPI from "../../../../apis/adminApi/AdminCashierAPI";
import FormContentLoader from "../../../loaders/FormContentLoader";
import Field from "../../../forms/Field";
import MyButton from "../../../assets/MyButton";
import {useForm} from "react-hook-form";

const AdminEditCashAccount = () => {

    const { formState } = useForm();
    const navigate = useNavigate();
    const { isSubmitting } = formState;
    const [loading, setLoading] = useState(true);
    let {cashAccountId} = useParams();

    const [showLoader, setShowLoader] = useState(false);

    const [cashAccount, setCashAccount] = useState({
       name : "", t_amount : "", currenct : "",id: cashAccountId
    });

    const [editing, setEditing] = useState(false);

    const [errors, setErrors] = useState({
        name : "", t_amount : "", currenct : "",
    });


    //Recuperation d'une facture
    const fetchCashAccount = async id => {
        try{
            const { name, t_amount, currency, id } = await AdminCashierAPI.findOneCashAccount(cashAccountId);
            setCashAccount({ name,t_amount, currency, id });
            setLoading(false);
        }catch(error){
            toast.error("Impossible de charger le compte source démandée !");
            navigate("/admin/cashier/cashAccounts");
        }
    };


    useEffect(() => {
        setEditing(true);
        fetchCashAccount(cashAccountId);
    }, [cashAccountId]);


    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setCashAccount({...cashAccount, [name] : value})
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await AdminCashierAPI.storeCashAccount(cashAccount);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Compte source modifié avec succès");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification !");
            }
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-7">
                    {loading && <FormContentLoader />}

                    {!loading && <form onSubmit={handleSubmit}>
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Modifier un compte source</h5>
                                        <div className="row">
                                            <div className="col-6">
                                                <Field
                                                    name="name"
                                                    error={errors.name}
                                                    value={cashAccount.name}
                                                    onChange={handleChange}
                                                    label="Nom du compte source"
                                                    placeholder="Nom"
                                                />

                                                <Field
                                                    name="t_amount"
                                                    type="number"
                                                    error={errors.t_amount}
                                                    value={cashAccount.t_amount}
                                                    onChange={handleChange}
                                                    label="Montant"
                                                    placeholder="000"
                                                />

                                                <label htmlFor="currency">Devise</label>
                                                <select className="form-control" disabled="disabled" name="currency" label="Devise"
                                                        value={cashAccount.currency} error={errors.currency}
                                                        onChange={handleChange}>
                                                    <option value="">Choisir...</option>
                                                    <option value="FC">CDF</option>
                                                    <option value="USD">USD</option>
                                                </select>
                                                {errors.currency && <div className="invalid-feedback mb-4">{errors.currency}</div>}
                                            </div>
                                        </div>
                                        <br/>

                                        <MyButton
                                            text="Modifier"
                                            onSubmit={handleSubmit}
                                            loading={showLoader}
                                            disabled={showLoader}
                                        />
                                        <Link to="/admin/cashier/cashAccounts" className="btn btn-info mx-2">Revenir aux compte sources</Link>
                                    </div>
                                </div>
                            </form>
                    }
                </div>
            </div>
        </div>
    );
};

export default AdminEditCashAccount;
